import { memo } from "react";
import { Outlet } from "react-router-dom";

import { type Platform } from "@telegram-apps/sdk";

import { cn } from "@arc/ui/cn";

import { SCROLL_CONTAINER_ID } from "@/constants/ui";

import BackButton from "./BackButton";
import { MainButton } from "./MainButton";
import { StyledToaster } from "./Toaster";

interface LayoutProps {
  platform: Platform;
}

export const Layout: React.FC<LayoutProps> = memo(() => (
  <div className="bg-background flex h-screen flex-col overflow-hidden">
    <StyledToaster />
    <div className="flex-grow overflow-y-auto" id={SCROLL_CONTAINER_ID}>
      <div
        className={cn({
          "m-auto box-border flex h-full w-full flex-col p-4": true,
        })}
      >
        <Outlet />
      </div>
    </div>

    <MainButton />
    <BackButton />
  </div>
));

Layout.displayName = "Layout";
